import {
    RegistrationForm
} from "../../Components/RegistrationForm/RegistrationForm"

export const RegistrationPage = function() {
    return (
        <div>
            <RegistrationForm/>
        </div>
    )
}